// extracted by mini-css-extract-plugin
export default {"wrapper":"FormatTooltipWrapper_wrapper__cOaQV","versionWrapper":"FormatTooltipWrapper_versionWrapper__GYajH","tip":"FormatTooltipWrapper_tip__5aw7f"};